var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWordLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4533 6H15.9413C14.9783 6 14.1973 6.781 14.1973 7.744V15.003H44.1973V7.744C44.1973 6.781 43.4163 6 42.4533 6Z",
    fill: "#2D92D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1973 33.054V40.256C14.1973 41.219 14.9783 42 15.9403 42H42.4533C43.4163 42 44.1973 41.219 44.1973 40.256V33.054H14.1973Z",
    fill: "#2150A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1973 15.003H44.1973V24.005H14.1973V15.003Z",
    fill: "#2D83D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1973 24.005H44.1973V33.055H14.1973V24.005Z",
    fill: "#2E70C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5163 34H5.87827C4.95027 34 4.19727 33.247 4.19727 32.319V15.681C4.19727 14.753 4.95027 14 5.87827 14H22.5163C23.4443 14 24.1973 14.753 24.1973 15.681V32.319C24.1973 33.247 23.4443 34 22.5163 34Z",
    fill: "#00488D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6003 19L17.0543 26.264L15.3413 19H13.1543L11.3873 26.489L9.79426 19H7.83826L10.1823 29H12.5343L14.2473 21.311L15.9613 29H18.2123L20.5563 19H18.6003Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordLogo);
export default __webpack_public_path__ + "static/media/word-logo.facd1055500c16f155971eb4d030c957.svg";
export { ForwardRef as ReactComponent };